import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  athlete: null,
  topPerforming: null,
  singleAthlete: null,
};

export const AthleteSlice = createSlice({
  name: "AthleteSlice",
  initialState,
  reducers: {
    setAthlete: (state, { payload }) => {
      state.athlete = payload;
      console.log(payload, "@all payload athlete");
    },
    setSingleAthlete: (state, { payload }) => {
      state.singleAthlete = payload;
      console.log(payload, "@single payload athlete");
    },
    setAddAthleteReferral: (state, { payload }) => {
      state.singleAthlete.referrers.push(payload);
      console.log(payload, "@add single referral payload athlete");
    },
    setUpdateAthleteReferral: (state, { payload }) => {
      state.singleAthlete.referrers = state.singleAthlete.referrers.map(
        (item) => {
          if (item._id === payload?._id) {
            return { ...item, ...payload };
          }
          return item;
        }
      );
    },
    setDeleteAthleteReferral: (state, { payload }) => {
      console.log(payload, "@athlete payload");
      state.singleAthlete.referrers = state.singleAthlete.referrers.filter(
        (item) => item._id !== payload?._id
      );
      console.log(payload, "@add single referral payload athlete");
    },
    setUpdateAthlete: (state, { payload }) => {
      console.log(payload, "@athlete payload");
      state.athlete.athletes = state.athlete.athletes.map((item) => {
        if (item._id === payload?._id) {
          return { ...item, ...payload };
        }
        return item;
      });
    },
    setDeleteAthlete: (state, { payload }) => {
      console.log(payload, "@athlete payload");
      state.athlete.athletes = state.athlete.athletes.filter(
        (item) => item._id !== payload?._id
      );
    },
    setTopPerforming: (state, { payload }) => {
      state.topPerforming = payload;
    },
  },
});

export const {
  setAthlete,
  setUpdateAthlete,
  setDeleteAthlete,
  setTopPerforming,
  setSingleAthlete,
  setAddAthleteReferral,
  setDeleteAthleteReferral,
  setUpdateAthleteReferral,
} = AthleteSlice.actions;
export default AthleteSlice.reducer;
